import {LetrusApi} from '@letrustech/letrus-api-interfaces';
import trophies from 'assets/images/trophies/trophies.webp';
import Achievements, {AchievementsColorName} from 'components/Achievements';
import {Button, Modal} from 'components/ui';
import React, {useEffect, useMemo, useState} from 'react';
import {
  getAchievementsSize,
  getLevelDescription,
  getTotalReviewLevelScore,
} from 'utils/functions/ReviewSideBar';
import {MappedCompetences} from '..';
import styles from './AchievementsGrade.module.scss';

export interface OwnProps {
  cycleType: number | undefined;
  genre: ImmutableMap<LetrusApi.Genre>;
  review: ImmutableMap<LetrusApi.CompositionReviewDetail>;
  competences: MappedCompetences[];
}

const AchievementsGrade: React.FC<OwnProps> = ({
  cycleType = 0,
  genre,
  review,
  competences,
}) => {
  const [level, setLevel] = useState<number>(0);
  const [modal, setModal] = useState(false);

  const handleModal = () => {
    setModal(!modal);
  };

  const levelDescription = useMemo(
    () =>
      getLevelDescription({
        genre,
        level,
        cycleType,
        review,
      }),
    [genre, level, cycleType, review],
  );
  useEffect(() => {
    setLevel(getTotalReviewLevelScore(review, competences));
  }, [review, competences]);

  return (
    <>
      <div className={styles.grade}>
        <Achievements
          cycle={cycleType}
          type="trophies"
          size={100}
          level={level}
        />
        <div className={styles.description}>
          <div className={styles.content}>
            <span>VOCÊ RECEBEU</span>
            <p>Troféu {AchievementsColorName(level)}</p>
            <p dangerouslySetInnerHTML={{__html: levelDescription}} />
          </div>
        </div>
        {cycleType === 2 && (
          <Button
            onClick={handleModal}
            variant="secondary"
            text=" O que são os troféus?"
          />
        )}
      </div>
      <Modal
        title="LISTA DE TROFÉUS"
        isOpen={modal}
        onClose={handleModal}
        clickOutsideToClose
      >
        <div className={styles.modal}>
          <img
            className={styles.modalHeader}
            src={trophies}
            alt="Achievements"
          />
          <p className={styles.modalDescription}>
            Os troféus são o reconhecimento do bom trabalho que você fez na
            redação, eles são uma conquista pelo seu esforço, dedicação e
            empenho na atividade realizada. Assim, conforme for escrevendo na
            Letrus, você sempre receberá um dos troféus da imagem abaixo e cada
            um deles te dará informações importantes sobre a sua redação. Isso
            te ajuda a entender a sua evolução na escrita, que pode variar entre
            1 e 5.
          </p>
          <div className={styles.modalImage}>
            {[1, 2, 3, 4, 5].map((item, index) => (
              <Achievements
                cycle={cycleType || 0}
                type="trophies"
                level={item}
                size={getAchievementsSize()}
                key={index.toString()}
              />
            ))}
          </div>
        </div>
      </Modal>
    </>
  );
};

export default AchievementsGrade;
